"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4392],{

/***/ 12492:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Unity = void 0;
var react_1 = __webpack_require__(91987);
var react_2 = __webpack_require__(91987);
var use_unity_canvas_id_1 = __webpack_require__(12055);
var use_unity_instance_1 = __webpack_require__(40711);
var use_unity_arguments_1 = __webpack_require__(68047);
var use_unity_loader_1 = __webpack_require__(29581);
/**
 * Renders the provided Unity Application.
 */
var Unity = (0, react_2.forwardRef)(
/**
 * @param unityProps The Unity props provided the the Unity component.
 * @param forwardedRef The forwarded ref to the Unity component.
 * @returns The Unity canvas renderer.
 */
function (unityProps, forwardedRef) {
    /**
     * A reference to the HTML Canvas Element. This Canvas Element will eventually
     * be passed to the Unity Instance hook which it will use to render the Unity
     * application.
     */
    var htmlCanvasElementRef = (0, react_2.useRef)(null);
    /**
     * A unique Unity canvas ID. This is used internally by Unity since version
     * 2021.2 to identify the canvas element in the DOM. This is not documented in
     * the Unity documentation, but it is used in the Unity source code.
     */
    var unityCanvasId = (0, use_unity_canvas_id_1.useUnityCanvasId)();
    /**
     * The Unity Arguments object which can be passed to the create Unity instance
     * method in order to initialize it. These arguments are created based on the
     * provided Unity Props which also include the Unity Provider and thus the
     * Unity Config.
     */
    var unityArguments = (0, use_unity_arguments_1.useUnityArguments)(unityProps);
    /**
     * The corresponding Unity Loader will be loaded based on the provided loader
     * URL from the Unity Provider's Unity Config.
     */
    var unityLoaderStatus = (0, use_unity_loader_1.useUnityLoader)(unityProps.unityProvider.unityConfig);
    // The Unity Instance is created based on the Unity Arguments. The loader
    // status will be used to determine if the Unity instance should be created.
    // The Unity is mounted to the Canvas Element.
    (0, use_unity_instance_1.useUnityInstance)(unityLoaderStatus, htmlCanvasElementRef.current, unityArguments, unityProps.unityProvider);
    // The imperative handle is used to pass the Canvas Element to the parent
    // component using the forwardRef.
    (0, react_1.useImperativeHandle)(forwardedRef, function () { return htmlCanvasElementRef.current; });
    // Returns the Unity Canvas Element which will render the Unity application.
    return (0, react_1.createElement)("canvas", {
        ref: htmlCanvasElementRef,
        id: unityCanvasId,
        style: unityProps.style,
        className: unityProps.className,
        tabIndex: unityProps.tabIndex,
    });
});
exports.Unity = Unity;


/***/ }),

/***/ 40820:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.errorMessages = void 0;
var errorMessages = {
    /**
     * A generic error message when the Unity Instance is not available.
     */
    genericNoUnityInstance: "No Unity Instance found.",
    /**
     * The error message for when no Unity Instance was found while trying to set
     * the fullscreen mode.
     */
    requestFullscreenNoUnityInstance: "Unable to Set Fullscreen while Unity is not Instantiated.",
    /**
     * The error message for when no Unity Instance was found while trying to
     * request the pointer lock.
     */
    requestPointerLockNoUnityInstanceOrCanvas: "Unable to Request Pointer Lock while Unity is not Instantiated or the Canvas is not found.",
    /**
     * The error message for when no Unity Instance was found while trying to send
     * a message.
     */
    sendMessageNoUnityInstance: "Unable to Send Message while Unity is not Instantiated.",
    /**
     * The error message for when no Unity Instance was found while trying to quit
     * the Unity Instance.
     */
    quitNoUnityInstance: "Unable to Quit Unity while Unity is not Instantiated.",
    /**
     * The error message for when no Unity Instance or Canvas was found while
     * trying to take a screenshot.
     */
    screenshotNoUnityInstanceOrCanvas: "Unable to Take Screenshot while Unity is not Instantiated or Canvas is not available.",
    /**
     * The error message for when no event listener was found in the event
     * system.
     */
    noEventListener: "Unable to find Event Listener in Event System for Event",
};
exports.errorMessages = errorMessages;


/***/ }),

/***/ 51466:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isBrowserEnvironment = void 0;
/**
 * Defines if the current environment is a browser environment. This is
 * determined by checking if the `window` and `document` objects are defined.
 */
exports.isBrowserEnvironment = typeof window !== "undefined" && typeof document !== "undefined";


/***/ }),

/***/ 93420:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UnityLoaderStatus = void 0;
/**
 * The status of the Unity loader.
 */
var UnityLoaderStatus;
(function (UnityLoaderStatus) {
    /**
     * The Unity loader is idling and awaiting a resource it be loaded.
     */
    UnityLoaderStatus["Idle"] = "Idle";
    /**
     * The Unity loader is loading a resource.
     */
    UnityLoaderStatus["Loading"] = "Loading";
    /**
     * The Unity loader has loaded a resource.
     */
    UnityLoaderStatus["Loaded"] = "Loaded";
    /**
     * The Unity loader has failed to load a resource.
     */
    UnityLoaderStatus["Error"] = "Error";
})(UnityLoaderStatus || (UnityLoaderStatus = {}));
exports.UnityLoaderStatus = UnityLoaderStatus;


/***/ }),

/***/ 34392:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.JM = exports.Y4 = void 0;
var unity_component_1 = __webpack_require__(12492);
Object.defineProperty(exports, "Y4", ({ enumerable: true, get: function () { return unity_component_1.Unity; } }));
var use_unity_context_1 = __webpack_require__(6511);
Object.defineProperty(exports, "JM", ({ enumerable: true, get: function () { return use_unity_context_1.useUnityContext; } }));


/***/ }),

/***/ 31758:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useEventSystem = void 0;
var react_1 = __webpack_require__(91987);
var error_messages_1 = __webpack_require__(40820);
var is_browser_environment_1 = __webpack_require__(51466);
/**
 * An array of dispatch event methods from within the mounted event systems.
 * This allows an event to be dispatched within all of the event system
 * instances.
 */
var mountedEventDispatchers = [];
/**
 * Dispatches an event to all mounted event systems.
 * @param eventName The name of the event to dispatch.
 * @param parameters The parameters to pass to the event listener.
 */
var dispatchReactUnityEvent = function (eventName) {
    var parameters = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        parameters[_i - 1] = arguments[_i];
    }
    // Loops through all of the mounted event systems and dispatches the event.
    // In case there are multiple event systems, the return value origin is
    // undefined.
    var returnValue = undefined;
    mountedEventDispatchers.forEach(function (dispatchEvent) {
        returnValue = dispatchEvent.apply(void 0, __spreadArray([eventName], parameters, false));
    });
    return returnValue;
};
if (is_browser_environment_1.isBrowserEnvironment === true) {
    // It is possible for the application being rendered server side. We'll check
    // if the app is running in a browser environment and if so, we'll make the
    // dispatch React Unity event function available to the global scope.
    window.dispatchReactUnityEvent = dispatchReactUnityEvent;
}
/**
 * Event system for invoking external React Unity events.
 * @returns The Event System hook.
 */
var useEventSystem = function () {
    /**
     * An array of all registered event listeners.
     */
    var eventListeners = (0, react_1.useRef)([]);
    /**
     * Adds an event listener for external React Unity events.
     */
    var addEventListener = (0, react_1.useCallback)(
    /**
     * @param eventName The name of the event to listen to.
     * @param callback The callback to invoke when the event is fired.
     */
    function (eventName, callback) {
        // Add the event listener will be added to the array of event listeners.
        eventListeners.current = __spreadArray(__spreadArray([], eventListeners.current, true), [
            { eventName: eventName, callback: callback },
        ], false);
    }, [eventListeners]);
    /**
     * Removes an event listener for external React Unity events.
     */
    var removeEventListener = (0, react_1.useCallback)(
    /**
     * @param eventName The name of the event to remove.
     * @param callback The callback to remove.
     */
    function (eventName, callback) {
        // The event listener will be filtered from the event listeners array
        // based on its name and the reference to the callback.
        eventListeners.current = eventListeners.current.filter(function (eventListener) {
            return eventListener.eventName !== eventName &&
                eventListener.callback !== callback;
        });
    }, [eventListeners]);
    /**
     * Dispatches an event.
     */
    var dispatchEvent = (0, react_1.useCallback)(
    /**
     * @param eventName The name of the event to dispatch.
     * @param parameters The parameters to pass to the event listener.
     */
    function (eventName) {
        var parameters = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            parameters[_i - 1] = arguments[_i];
        }
        // The event listener will be filtered from the event listeners array
        // based on its name.
        var eventListener = eventListeners.current.find(function (eventListener) { return eventListener.eventName === eventName; });
        if (typeof eventListener === "undefined") {
            // Guarding the event listener.
            console.warn(error_messages_1.errorMessages.noEventListener, { eventName: eventName });
            return;
        }
        // The event listener will be invoked with the parameters.
        return eventListener.callback.apply(eventListener, parameters);
    }, [eventListeners]);
    // Effect ensures that the dispatch event function is available to the
    // global array of event listeners. This allows the global method to dispatch
    // events within the event system hooks.
    (0, react_1.useEffect)(function () {
        mountedEventDispatchers.push(dispatchEvent);
        return function () {
            mountedEventDispatchers.splice(mountedEventDispatchers.indexOf(dispatchEvent), 1);
        };
    }, [dispatchEvent]);
    return {
        addEventListener: addEventListener,
        removeEventListener: removeEventListener,
    };
};
exports.useEventSystem = useEventSystem;


/***/ }),

/***/ 47684:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useNullableState = void 0;
var react_1 = __webpack_require__(91987);
/**
 * A hook that creates a nullable state.
 * @param initialState Optional initial state, defaults to null.
 * @returns a stateful value, and a function to update it.
 */
var useNullableState = function (initialState) {
    return (0, react_1.useState)(initialState || null);
};
exports.useNullableState = useNullableState;


/***/ }),

/***/ 68047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useUnityArguments = void 0;
var react_1 = __webpack_require__(91987);
/**
 * Creates a memoized Unity Arguments object which can be passed to the Unity
 * instance in order to initialize it.
 * @param unityProps The Unity props provided the the Unity component.
 * @returns The Unity arguments to pass to the Unity instance.
 */
var useUnityArguments = function (unityProps) {
    return (0, react_1.useMemo)(function () { return ({
        // Assigns the data URL, framework URL, and code URL to the Unity
        // arguments object.
        dataUrl: unityProps.unityProvider.unityConfig.dataUrl,
        frameworkUrl: unityProps.unityProvider.unityConfig.frameworkUrl,
        codeUrl: unityProps.unityProvider.unityConfig.codeUrl,
        // Assigns the optional streaming assets URL, memory URL, and symbols URL
        // to the Unity arguments object.
        streamingAssetsUrl: unityProps.unityProvider.unityConfig.streamingAssetsUrl,
        memoryUrl: unityProps.unityProvider.unityConfig.memoryUrl,
        symbolsUrl: unityProps.unityProvider.unityConfig.symbolsUrl,
        // Assigns the optional company name, product name, and product version to
        // the Unity arguments object.
        companyName: unityProps.unityProvider.unityConfig.companyName,
        productName: unityProps.unityProvider.unityConfig.productName,
        productVersion: unityProps.unityProvider.unityConfig.productVersion,
        // Assigns the webgl context attributes to the Unity arguments object.
        // If the webgl context attributes are not defined via the Unity Props,
        // the default value of an empty object will be used.
        webglContextAttributes: unityProps.unityProvider.unityConfig.webglContextAttributes || {},
        // Assigns the cache control value to the Unity arguments object. If the
        // cache control value is not defined via the Unity Props, the default
        // value of always `must-revalidate` will be used.
        cacheControl: unityProps.unityProvider.unityConfig.cacheControl ||
            (function () { return "must-revalidate"; }),
        // Assigns the device pixel ratio to the Unity arguments object. If the
        // device pixel ratio is not defined via the Unity Props, the default
        // value of `1` will be used.
        devicePixelRatio: unityProps.devicePixelRatio || 1,
        // Assigns the match WebGL to canvas size value to the Unity arguments
        // object. If the match WebGL to canvas size value is not defined via the
        // Unity Props, the default value of `true` will be used.
        matchWebGLToCanvasSize: typeof unityProps.matchWebGLToCanvasSize === "boolean"
            ? unityProps.matchWebGLToCanvasSize
            : true,
        // Assigns the disabled canvas events to the Unity arguments object. If
        // the disabled canvas events are not defined via the Unity Props, the
        // default value of `contextmenu` and `dragstart` will be used.
        disabledCanvasEvents: unityProps.disabledCanvasEvents || [
            "contextmenu",
            "dragstart",
        ],
        // Assigns the print hook to the Unity arguments object. This hook will
        // be called whenever the Unity instance prints a message.
        print: 
        /**
         * Intercept print events in order to catch messages and send them to
         * the unity context instead.
         * @param message The message to be printed.
         */
        function (message) {
            // TODO -- Re-implement this hook.
        },
        // Assigns the print error hook to the Unity arguments object. This hook
        // will be called whenever the Unity instance prints an error.
        printErr: 
        /**
         * Intercept print error events in order to catch messages and send them
         * to the unity context instead.
         * @param error The error to be printed.
         */
        function (error) {
            // TODO -- Re-implement this hook.
        },
    }); }, []);
};
exports.useUnityArguments = useUnityArguments;


/***/ }),

/***/ 12055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useUnityCanvasId = void 0;
var react_1 = __webpack_require__(91987);
/**
 * The canvas count is used to generate a unique Unity canvas ID.
 */
var unityCanvasCount = 0;
/**
 * The prefix used to generate a unique Unity canvas ID.
 */
var unityCanvasIdPrefix = "react-unity-webgl-canvas";
/**
 * Generates a unique Unity canvas ID. This is used internally by Unity since
 * version 2021.2 to identify the canvas element in the DOM. This is not
 * documented in the Unity documentation, but it is used in the Unity source
 * code.
 * @returns A unique identifier for a Unity canvas element.
 */
var useUnityCanvasId = function () {
    /**
     * A unique identifier for a Unity canvas element is memorized.
     */
    var unityCanvasId = (0, react_1.useMemo)(function () {
        // The Unity canvas ID is generated by concatenating the Unity canvas ID
        // prefix with the canvas count. Every time this value is requested, the
        // canvas count is incremented.
        return [unityCanvasIdPrefix, ++unityCanvasCount].join("-");
    }, []);
    return unityCanvasId;
};
exports.useUnityCanvasId = useUnityCanvasId;


/***/ }),

/***/ 6511:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useUnityContext = void 0;
var react_1 = __webpack_require__(91987);
var error_messages_1 = __webpack_require__(40820);
var use_event_system_1 = __webpack_require__(31758);
var use_nullable_state_1 = __webpack_require__(47684);
/**
 * Creates a Unity Context hook.
 * @param unityConfig The Unity Config on which the Unity Context is based.
 * @returns The Unity Context hook.
 */
var useUnityContext = function (unityConfig) {
    // A reference to the Unity Instance.
    var _a = (0, use_nullable_state_1.useNullableState)(), unityInstance = _a[0], setUnityInstance = _a[1];
    // The Unity Instance's loading progression represents the percentage of the
    // Unity Instance's loading process that has been completed.
    var _b = (0, react_1.useState)(0), loadingProgression = _b[0], setLoadingProgression = _b[1];
    // Defines whether the Unity Instance has been loaded.
    var _c = (0, react_1.useState)(false), isLoaded = _c[0], setIsLoaded = _c[1];
    // May contain an error that occurred during the initialisation of the Unity
    // Instance.
    var _d = (0, use_nullable_state_1.useNullableState)(), initialisationError = _d[0], setInitialisationError = _d[1];
    /**
     * The Unity Context's event system stores the event listeners which will
     * allow Unity or any global source to invoke events to the React application.
     */
    var eventSystem = (0, use_event_system_1.useEventSystem)();
    /**
     * The Unity Context returns a Unity Provider instance. This is an immutable
     * object that contains a series of methods and properties that are used to
     * alter the Unity Context state externally.
     */
    var unityProvider = (0, react_1.useRef)({
        setLoadingProgression: setLoadingProgression,
        setInitialisationError: setInitialisationError,
        setUnityInstance: setUnityInstance,
        setIsLoaded: setIsLoaded,
        unityConfig: unityConfig,
    });
    /**
     * Enables or disabled the Fullscreen mode of the Unity Instance.
     */
    var requestFullscreen = (0, react_1.useCallback)(
    /**
     * @param enabled Defines whether Unity should be in fullscreen.
     */
    function (enabled) {
        if (unityInstance === null) {
            // Guarding the Unity Instance.
            console.warn(error_messages_1.errorMessages.requestFullscreenNoUnityInstance);
            return;
        }
        // For undocumented reasons, the fullscreen mode can only be enabled
        // with an interger value where the value of "1" enables the fullscreen
        // mode and the value of "0" disables the fullscreen mode.
        unityInstance.SetFullscreen(enabled === true ? 1 : 0);
    }, [unityInstance]);
    /**
     * Lets you asynchronously ask for the pointer to be locked on the given Unity
     * Application's Canvas Element.
     */
    var requestPointerLock = (0, react_1.useCallback)(function () {
        if (unityInstance === null ||
            typeof unityInstance.Module.canvas === "undefined") {
            // Guarding the Unity Instance and the canvas.
            console.warn(error_messages_1.errorMessages.requestPointerLockNoUnityInstanceOrCanvas);
            return;
        }
        // Requesting the pointer lock.
        return unityInstance.Module.canvas.requestPointerLock();
    }, [unityInstance]);
    /**
     * Sends a message to the UnityInstance to invoke a public method.
     */
    var sendMessage = (0, react_1.useCallback)(
    /**
     * @param gameObjectName the name of the game object in your Unity scene.
     * @param methodName the name of the public method on the game object.
     * @param parameter an optional parameter to pass along to the method.
     */
    function (gameObjectName, methodName, parameter) {
        if (unityInstance === null) {
            // Guarding the Unity Instance.
            console.warn(error_messages_1.errorMessages.sendMessageNoUnityInstance);
            return;
        }
        unityInstance.SendMessage(gameObjectName, methodName, parameter);
    }, [unityInstance]);
    /**
     * Takes a screenshot of the Unity Instance and returns a base64 encoded
     * string.
     */
    var takeScreenshot = (0, react_1.useCallback)(
    /**
     * @param dataType Defines the type of screenshot to take.
     * @param quality Defines the quality of the screenshot.
     * @returns A base 64 encoded string of the screenshot.
     */
    function (dataType, quality) {
        if (unityInstance === null ||
            typeof unityInstance.Module.canvas === "undefined") {
            // Guarding the Unity Instance and the canvas.
            console.warn(error_messages_1.errorMessages.screenshotNoUnityInstanceOrCanvas);
            return;
        }
        // Takes a screenshot by converting Canvas's render-context's buffer into
        // a Data URL of the specified data type and quality.
        return unityInstance.Module.canvas.toDataURL(dataType, quality);
    }, [unityInstance]);
    /**
     * Requests the UnityInstance to be unloaded from memory in order to be
     * unmounted from the DOM.
     */
    var unload = (0, react_1.useCallback)(
    /**
     * @returns A promise that resolves when the UnityInstance has been unloaded.
     */
    function () {
        if (unityInstance === null) {
            // Guarding the Unity Instance.
            console.warn(error_messages_1.errorMessages.quitNoUnityInstance);
            return Promise.reject();
        }
        return unityInstance.Quit();
    }, [unityInstance]);
    // Effect invoked when the loading progression changes. When the loading
    // progression is equal to or more than 1, the Unity Instance is considered
    // loaded. This will update the isLoaded state.
    (0, react_1.useEffect)(function () {
        setIsLoaded(loadingProgression === 1);
    }, [loadingProgression]);
    // Returns the Unity Context Hook.
    return {
        unityProvider: unityProvider.current,
        loadingProgression: loadingProgression,
        initialisationError: initialisationError,
        isLoaded: isLoaded,
        UNSAFE__unityInstance: unityInstance,
        requestFullscreen: requestFullscreen,
        requestPointerLock: requestPointerLock,
        sendMessage: sendMessage,
        unload: unload,
        takeScreenshot: takeScreenshot,
        addEventListener: eventSystem.addEventListener,
        removeEventListener: eventSystem.removeEventListener,
    };
};
exports.useUnityContext = useUnityContext;


/***/ }),

/***/ 40711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useUnityInstance = void 0;
var react_1 = __webpack_require__(91987);
var unity_loader_status_1 = __webpack_require__(93420);
var is_browser_environment_1 = __webpack_require__(51466);
/**
 * Creates a Unity Instance.
 * @param unityLoaderStatus The loader status.
 * @param htmlCanvasElement A reference to the html canvas element.
 * @param unityArguments The Unity instance arguments.
 * @param unityProvider The Unity provider.
 * @returns the Unity Instance among with the status of the Unity Instance.
 */
var useUnityInstance = function (unityLoaderStatus, htmlCanvasElement, unityArguments, unityProvider) {
    // Effect invoked when the Unity Loader status or canvas reference changes.
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var unityInstance, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // It is possible for the application being rendered server side. In
                        // this scenario, the window is not available. We can't create the
                        // Unity Instance in this case.
                        if (is_browser_environment_1.isBrowserEnvironment === false) {
                            return [2 /*return*/];
                        }
                        if (unityLoaderStatus !== unity_loader_status_1.UnityLoaderStatus.Loaded ||
                            htmlCanvasElement === null) {
                            // If the loader is not loaded, or the canvas is not available,
                            // we can't create the Unity instance yet. In case of a fresh load,
                            // we'll clear the initialisation error as well.
                            unityProvider.setUnityInstance(null);
                            unityProvider.setInitialisationError(null);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, window.createUnityInstance(htmlCanvasElement, unityArguments, unityProvider.setLoadingProgression)];
                    case 2:
                        unityInstance = _a.sent();
                        // When the Unity Instance is created, its reference is stored in the
                        // state while the error state is cleared.
                        unityProvider.setUnityInstance(unityInstance);
                        unityProvider.setInitialisationError(null);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        // When the Unity Instance catches due to a fail during the creation,
                        // the Unity Instnace reference will be cleared while the error is
                        // placed into the state.
                        unityProvider.setUnityInstance(null);
                        unityProvider.setInitialisationError(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [unityLoaderStatus, htmlCanvasElement, unityArguments, unityProvider]);
};
exports.useUnityInstance = useUnityInstance;


/***/ }),

/***/ 29581:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useUnityLoader = void 0;
var react_1 = __webpack_require__(91987);
var is_browser_environment_1 = __webpack_require__(51466);
var unity_loader_status_1 = __webpack_require__(93420);
/**
 * Hook to embed a Unity Loader script.
 * @param source The source of the unity loader.
 * @returns a hook that returns the status of the loader.
 */
var useUnityLoader = function (unityConfig) {
    var _a = (0, react_1.useState)(unity_loader_status_1.UnityLoaderStatus.Loading), status = _a[0], setStatus = _a[1];
    // Effect hook will be invoked when the source changes.
    (0, react_1.useEffect)(function () {
        // It is possible for the application being rendered server side. In
        // this scenario, the window is not available. We can't create a Unity
        // Loader in this case.
        if (is_browser_environment_1.isBrowserEnvironment === false) {
            return;
        }
        // If the script's source is null, we'll reset the status to idle.
        if (unityConfig.loaderUrl === null) {
            setStatus(unity_loader_status_1.UnityLoaderStatus.Idle);
            return;
        }
        /**
         * Find existing script element by source. It may have been added by
         * another instance of this hook.
         */
        var script = window.document.querySelector("script[src=\"".concat(unityConfig.loaderUrl, "\"]"));
        // If there wan't another instance of this script, we're going to create a
        // new one with the provided source.
        if (script === null) {
            script = window.document.createElement("script");
            script.type = "text/javascript";
            script.src = unityConfig.loaderUrl;
            script.async = true;
            script.setAttribute("data-status", "loading");
            // Add script to window.document body.
            window.document.body.appendChild(script);
            // Store status in attribute on script. This can be read by other
            // instances of this hook.
            script.addEventListener("load", function () {
                return script === null || script === void 0 ? void 0 : script.setAttribute("data-status", "loaded");
            });
            script.addEventListener("error", function () {
                return script === null || script === void 0 ? void 0 : script.setAttribute("data-status", "error");
            });
        }
        else {
            // If there already was a script with the same source, grab its existing
            // script status from attribute and set to state.
            setStatus(script.getAttribute("data-status") === "loaded"
                ? unity_loader_status_1.UnityLoaderStatus.Loaded
                : unity_loader_status_1.UnityLoaderStatus.Error);
        }
        /**
         * Script event handler to update status in state. Even if the script
         * already exists we still need to add event handlers to update the state
         * for this hook instance.
         * @param event The event that was triggered.
         */
        var setStateFromEvent = function (event) {
            return setStatus(event.type === "load"
                ? unity_loader_status_1.UnityLoaderStatus.Loaded
                : unity_loader_status_1.UnityLoaderStatus.Error);
        };
        script.addEventListener("load", setStateFromEvent);
        script.addEventListener("error", setStateFromEvent);
        // Remove event listeners on cleanup.
        return function () {
            if (script !== null) {
                script.removeEventListener("load", setStateFromEvent);
                script.removeEventListener("error", setStateFromEvent);
                window.document.body.removeChild(script);
            }
        };
    }, [unityConfig.loaderUrl]);
    return status;
};
exports.useUnityLoader = useUnityLoader;


/***/ })

}]);